import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "build-group-dialog-floating-delete-info-text",
  class: "gordita-400-12 w-[279px]"
}
const _hoisted_2 = { class: "row gap-[8px]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ibf-gordita-12-m text-Text/text_high" }, "Cancel")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ibf-gordita-12-m" }, "Delete")
], -1)

import { IncrediButton } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'deleteInfoCell',
  props: {
    message: null
  },
  emits: ['cancel-delete', 'delete-row', 'click-outside'],
  setup(__props: any, { emit }) {


const target = ref(null);


onClickOutside(target, event => emit('click-outside', event));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "target",
        ref: target,
        class: "bg-System/app_white h-full pointer-events-auto flex justify-between gap-[8px] pl-[24px] pr-[16px] py-[8px] w-[592px]",
        "data-testid": "build-group-dialog-floating-delete-info-cell"
      }, [
        _createElementVNode("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(__props.message), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IncrediButton), {
            "data-testid": "build-group-dialog-floating-delete-info-cell-cancel-button",
            design: "ghost-grey",
            size: "big",
            onClick: _cache[0] || (_cache[0] = () => emit('cancel-delete'))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_unref(IncrediButton), {
            "data-testid": "build-group-dialog-floating-delete-info-cell-delete-button",
            design: "primary-red",
            size: "big",
            onClick: _cache[1] || (_cache[1] = () => emit('delete-row'))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ])
      ], 512)
    ]),
    _: 3
  }))
}
}

})